import React, { useState } from "react";
import Img from "../../Images/OurWork/common-banner.jpg";

const MVV = () => {
  const [toggle, setToggle] = useState("mission");

  const tabs = [
    { key: "mission", label: "Mission" },
    { key: "vision", label: "Vision" },
    { key: "values", label: "Values" },
  ];

  return (
    <div className="min-h-screen flex flex-col md:flex-row gap-2 lg:gap-4  bg-lightZinc shadow-lg my-7 md:my-20">
      {/* ********************************* Left Image Section ********************************* */}

      <div className="w-full md:w-1/2">
        <img
          src={Img}
          alt="Mission-Vision-Values Visual"
          className="w-full h-full object-cover  shadow-md"
        />
      </div>

      {/* ********************************* Right Content Section ********************************* */}

      <div className="w-full md:w-1/2 p-5 md:p-14  flex flex-col">
        <h2 className="text-xl uppercase font-edu-sa  md:text-3xl font-bold text-center text-ndlogoBlue mb-8">
          Concern about Our Mission
        </h2>

        {/* ********************************* Tabs **********************************/}

        <div className="flex justify-center md:justify-between border-b border-lightGray mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setToggle(tab.key)}
              className={`text-base  md:text-lg font-serif font-semibold px-4 py-2 transition-colors duration-200  ${
                toggle === tab.key
                  ? "text-Orange border-b-4 border-Orange scale-100 hover:scale-105 transition-transform duration-300"
                  : "text-ndlogoBlue border-transparent hover:text-Orange"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* ********************************* Tab Content ********************************* */}

        <div className=" text-mediumGray  leading-relaxed space-y-2 md:space-y-4 ">
          {toggle === "mission" && (
            <>
              <p>
                New Directions is committed to advancing social and economic
                equity by:
              </p>
              <ul className=" pl-5 space-y-2">
                <li type="square">
                  Bridging the skill gap through industry-aligned training for
                  youth and graduates.
                </li>
                <li type="square">
                  Empowering rural women with livelihood opportunities and
                  mobility support.
                </li>
                <li type="square">
                  Promoting environmental responsibility through awareness
                  campaigns and green initiatives.
                </li>
                <li type="square">
                  Supporting India’s elderly through compassionate,
                  community-based care systems.
                </li>
                <li type="square">
                  We work at the intersection of education, gender equity,
                  climate action, and elder welfare to create lasting impact and
                  systemic change.
                </li>
              </ul>
            </>
          )}

          {toggle === "vision" && (
            <p>
              The vision of NDES is centred on cultivating a world where every
              individual is afforded the opportunity to realize their full
              potential, irrespective of background or circumstance. We envisage
              a society wherein education, empowerment, and sustainable
              practices form the bedrock of progress and well-being.
            </p>
          )}

          {toggle === "values" && (
            <>
              <ul className="list-disc pl-5 space-y-2">
                <li type="square">
                  <strong className="text-Orange">Empathy:</strong> Guided by a
                  deep understanding of the diverse needs and aspirations of the
                  communities we serve.
                </li>
                <li type="square">
                  <strong className="text-Orange">Integrity:</strong> Our
                  actions are steered by principles of honesty, transparency,
                  and unwavering commitment to ethical practices.
                </li>
                <li type="square">
                  <strong className="text-Orange">Collaboration:</strong> We
                  recognize and actively seek the strength in partnerships,
                  maximizing our impact through collaborative endeavours.
                </li>
                <li type="square">
                  <strong className="text-Orange">Innovation:</strong> Embracing
                  creativity and innovation as instrumental forces for driving
                  positive change.
                </li>
                <li type="square">
                  <strong className="text-Orange">Sustainability:</strong> Our
                  commitment to sustainability is manifested through efforts
                  aimed at creating lasting and meaningful impact.
                </li>
              </ul>
              <p>
                Together, we can forge a brighter future for all. At New
                Directions Educational Society (NDES), we believe in
                transforming potential into proficiency, guiding each individual
                towards success and self-discovery.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MVV;
